import React from 'react';
import image from '../../assets/customersoftware.png';
import ServiceTech from '../../component/servicetech'
import aiheader from '../../assets/ai_header.jpg';
import aikey1 from '../../assets/ai_key1.jpg';
import aikey2 from '../../assets/ai_key2.jpg';
import aikey3 from '../../assets/ai_key3.jpg';
const Ai = () => {
  const data =  {
    "headerimg":aikey2,
    "key1img":aikey1,
    "key2img":aiheader,
    "key3img":aikey3,
    "maintitle":"Intelligence is not about machines thinking—it's about them helping us think smarter",
    "mainsub":"Innovating the Future with AI-Driven Solutions",

    "title":"Artificial Intelligence",
    "subtext":"Our AI services bring advanced technology solutions that transform the way businesses operate. From intelligent automation to predictive analytics, we leverage AI to improve decision-making, optimize processes, and enhance customer experiences. Whether you're exploring AI for the first time or scaling existing systems, we tailor solutions to drive meaningful impact.",
    "choose1": "We deliver advanced AI systems designed to automate complex decision-making processes while boosting operational efficiency. Our solutions enable innovative business strategies tailored specifically to your unique needs, ensuring you remain competitive. With our expertise, you can leverage AI technologies that enhance your capabilities and drive significant results for your organization.",
    
    "choose2": "Our AI solutions utilize predictive analytics to help your business stay ahead of market trends and optimize operations effectively. By making informed, data-driven decisions, you can achieve sustainable growth and navigate the complexities of the marketplace. Our tailored approach ensures your organization thrives in a dynamic, evolving environment.",
    
    "choose3": "We ensure that AI technologies are seamlessly integrated into your existing workflows, providing immediate value while enhancing productivity. Our solutions deliver impactful results without disruptions, allowing your teams to adapt quickly. With our support, you can maximize the potential of AI and drive significant advancements in your operational effectiveness.",
   "key1":"Intelligent Automation",
    "key2":"Predictive Analytics",
    "key3":"Personalized Customer Experience",
    "key4":"Advanced Machine Learning",
    "key5":"Business Innovation",
    "text1":"AI solutions enhance process automation by enabling machines to handle complex decision-making tasks, improving operational efficiency and reducing manual intervention.",
    "text2":"With AI, businesses can leverage predictive analytics to forecast trends, identify opportunities, and make data-driven decisions to stay ahead of the competition.",
    "text3":"AI-powered systems allow businesses to offer personalized experiences at scale, using customer data and behavior analysis to drive engagement and satisfaction.",
    "text4":"Our AI solutions include machine learning models that continuously improve over time, providing better insights, smarter automation, and more accurate predictions.",
    "text5":"AI helps businesses innovate by identifying new opportunities, streamlining operations, and creating a competitive edge through technology-driven solutions.",
    "text6":"With our expertise in Artificial Intelligence (AI) and Intelligent Automation, organizations can rethink, re-engineer, and streamline their operations for enhanced performance."




}

  return (

 

  <>
    <ServiceTech values={data} />
  </>

    
 
)
};

export default Ai;
